<template>
  <div style="height:100%;" class="d-flex justify-center">
    <div class="d-flex flex-column align-center pa-4 mt-8" style="max-width:600px">
      <LoginForm></LoginForm>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
export default {
  name: "Login",
  components: {
    LoginForm
  },
  data: () => ({})
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
